





























import Vue from "vue";
import $store from "@/store/store";
import Component from "vue-class-component";
import NumericPad from "@/ui-component/numericPad.vue";

@Component({
  components: {
    NumericPad,
  },
})
export default class CodeDial extends Vue {
  public contrecode = "";
  public code = 0;
  public contreCodeError = false;

  public mounted() {
    this.code = Math.floor(Math.random() * 6999) + 5555;
  }

  public writeTxt(text: string) {
    // console.log("write", text);
    switch (text) {
      case "C":
        this.contrecode = "";
        break;
      default:
        this.contrecode += "" + text;
        break;
    }
  }

  public exit() {
    this.code = Math.floor(Math.random() * 6999) + 5555;
    this.contrecode = "";
  }

  public checkCode(contrecode: any, ev: any) {
    this.contreCodeError = false;
    if (contrecode === "" || contrecode === undefined) {
      this.contreCodeError = true;
      /*  $scope.bounce = true;
            $timeout(function () {
                $scope.bounce = false;
            }, 800);*/
      return;
    }
    this.$store
      .dispatch("bdd/checkContreCode", { code: this.code, contrecode })
      .then(
        (data: any) => {
          console.log(data);
          if (data.data === true) {
            this.contreCodeError = false;
            this.validateCode(true);
            // console.log("youpi");
          } else {
            this.validateCode(false);
            this.contreCodeError = true;
          }
        },
        (error) => {
          this.contreCodeError = true;
          /*var noSites = gettextCatalog.getString('commError');
            var toast = $mdToast.simple()
                .textContent(noSites)
                .action('OK')
                .highlightAction(false)
                .hideDelay(6000)
                .theme('errorToast')
                .position("top right");
            $mdToast.show(toast).then(function () {
                $mdToast.hide();
            });*/
        }
      );
  }

  private validateCode(isvalidated: boolean) {
    this.$emit("validateCode", isvalidated);
  }
}
